module.exports = __webpack_public_path__ + "img/30.b36bbcf6.svg";